export const BASE_URL       = 'https://hawaya.electronicvillage.org';
export const FACEBOOK_ID    = '417627370958302'
export const GOOGLE_ID      = '197218542246-et00rtb39j5at21qcqhf3t65nku7i2of.apps.googleusercontent.com'
export const USER_HOST      = 'https://evusers.electronicvillage.org'
export const RECAPTCHA      = '6LeEz_0hAAAAALYs3I-jTE3dvdC6JNAWnnD1jUUK'
export const APP_ID         = '19'